module.exports = __webpack_public_path__ + "img/productBgImg18.719d005d.png";